import { useQuery } from '@tanstack/react-query';
import { BannersQueryModel, MoviesQueryModel } from '../types';
import { getHomePageData } from '@http/endpoints/home';

type HomePageQueryModel = {
  movies: MoviesQueryModel;
  status: string;
  message: string | null;
  banners: BannersQueryModel;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
};

const useHomePageQuery = (): HomePageQueryModel => {
  const { data, isLoading, isError, isSuccess } = useQuery(['homepage'], getHomePageData);
  const banners = data?.data?.banners;
  const movies = data?.data?.movies;
  const status = data?.status;
  const message = data?.message;

  return { movies, status, message, banners, isLoading, isError, isSuccess } as any;
};

export default useHomePageQuery;
